<template>
  <div
    :class="['flex flex-column site-page-card silo-card mb-8 p-5', !isCardInEditMode?'cursor-pointer':'']"
    @click="!isCardInEditMode ? onSiloClick() : undefined"
    @mousedown.middle.prevent="!isCardInEditMode ? onSiloClick('middle') : undefined"
  >
    <div class="silo-card-head">
      <div
        class="silo-card-title"
      >
        <div class="project-name">
          <span
            v-if="!isCardInEditMode"
            style="cursor:text;"
            @click.stop="editedName = silo.name; isCardInEditMode = true;"
          >
            {{ silo.name }}
          </span>
          <v-text-field
            v-else
            autofocus
            outlined
            v-model="editedName"
            @blur="saveEditName()"
            @keypress.enter="saveEditName()"
            dense
            hide-details
            style="max-width: max-content; background-color: white"
          >
          </v-text-field>
        </div>
        <b-tooltip
          v-if="countValue"
          :label="`Number of ${silo?.content_report_order?.order_status === 'paid' ? 'ordered' : 'selected'} keywords`"
          type="is-dark"
        >
          <div class="count-label">
            {{ countValue }}
          </div>
        </b-tooltip>
      </div>

      <div
        class="is-size-6 title-font mainColor--text"
        style="margin-top: -3px;"
      >
        <v-btn icon :id="`dot-menu-for-${silo.id}`">
          <span
            class="material-icons-outlined mainColor--text"
            style="font-size: 30px"
            >more_horiz</span
          >
        </v-btn>
        <v-menu :activator="`#dot-menu-for-${silo.id}`" bottom offset-y>
          <v-list>
            <v-list-item v-if="isMissionControlSession" @click="onSiloClick('middle')">
              <v-list-item-title class="mainColor--text">
                Open in new tab
              </v-list-item-title>
            </v-list-item>
            <template v-if="isProjectLevelView">
              <v-list-item
                v-if="!silo.pageId"
                @click="showConnectToPageModal = true"
              >
                <v-list-item-title class="mainColor--text">
                  Connect to page
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-else
                @click="updateSilo({pageId: null}, true)"
              >
                <v-list-item-title
                  class="mainColor--text"
                >
                  Disconnect from page<br/>
                  <small class="grayColor--text text--darken-4">{{ silo?.page?.name }}</small>
                </v-list-item-title>
              </v-list-item>
            </template>
            <v-list-item @click="showDeleteConfirmModal = true">
              <v-list-item-title class="mainColor--text">
                Delete
              </v-list-item-title>
            </v-list-item>
            <template v-if="isWhiteGloveUser && isMissionControlSession && silo?.content_report_order?.order_status === 'paid'">
              <v-list-item
                v-if="silo.content_report_order.fulfillement_status !== 'pending'"
                @click="updateOrder({set_pending: true})"
              >
                <v-list-item-title class="mainColor--text">
                  Mark as {{ getFulfillementStatusLabel('pending')}}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="silo.content_report_order.fulfillement_status !== 'in_progress'"
                @click="updateOrder({set_in_progress: true})"
              >
                <v-list-item-title class="mainColor--text">
                  Mark as {{ getFulfillementStatusLabel('in_progress')}}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="silo.content_report_order.fulfillement_status !== 'completed'"
                @click="updateOrder({set_completed: true})"
              >
                <v-list-item-title class="mainColor--text">
                  Mark as {{ getFulfillementStatusLabel('completed')}}
                </v-list-item-title>
              </v-list-item>
            </template>
            <template v-else-if="!isWhiteGloveUser">
              <v-list-item
                v-if="silo.fulfillement_status !== 'pending'"
                @click="updateSilo({fulfillement_status: 'pending'}, true)"
              >
                <v-list-item-title class="mainColor--text">
                  Mark as New
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="silo.fulfillement_status !== 'in_progress'"
                @click="updateSilo({fulfillement_status: 'in_progress'}, true)"
              >
                <v-list-item-title class="mainColor--text">
                  Mark as {{ getFulfillementStatusLabel('in_progress')}}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="silo.fulfillement_status !== 'completed'"
                @click="updateSilo({fulfillement_status: 'completed'}, true)"
              >
                <v-list-item-title class="mainColor--text">
                  Mark as {{ getFulfillementStatusLabel('completed')}}
                </v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
      </div>
    </div>
    <div class="mt-1 mainColor--text font-weight-regular">
      Updated {{ showElaspedTime(silo.updatedAt) }}
    </div>
    <footer class="footer-container">
      <div
        class="footer-item"
      >
        <b-dropdown
          v-if="isWhiteGloveUser"
          aria-role="list" @click.native.stop class="page-type-drodown" :disabled="isWhiteGloveUser && !isMissionControlSession"
        >
          <template #trigger>
            <v-btn
              v-if="silo.pageType === 'new'"
              class="page-type-btn"
              small
            >
              New page
            </v-btn>
            <v-btn
              v-else-if="silo.pageType === 'existing'"
              class="page-type-btn"
              small
            >
              Existing page
            </v-btn>
            <b-tooltip
              v-else-if="isMissionControlSession"
              label="Assign page type"
              type="is-dark"
            >
              <v-btn
                class="page-type-assign-btn"
                rounded icon
              >
                <i class="material-icons-outlined" style="font-size: 1.2rem;">description</i>
              </v-btn>
            </b-tooltip>
          </template>
          <b-dropdown-item aria-role="listitem" @click.native.stop="updateSilo({pageType: 'new'}, true)">New page</b-dropdown-item>
          <b-dropdown-item aria-role="listitem" @click.native.stop="updateSilo({pageType: 'existing'}, true)">Existing page</b-dropdown-item>
        </b-dropdown>
      </div>
      <div
        v-if="['in_cart', 'in_cart_checkout'].includes(silo?.content_report_order?.order_status)"
        class="footer-item"
      >
        <span class="material-icons-outlined">shopping_cart</span>
        <span class="price-on-checkout">Order in cart</span>
      </div>
      <div
        v-if="['paid', 'to_be_paid_by_invoice'].includes(silo?.content_report_order?.order_status) && silo?.content_report_order?.price_on_checkout"
        class="footer-item footer-item-price-on-checkout"
      >
        <span v-if="silo?.content_report_order?.order_status === 'to_be_paid_by_invoice'" class="material-icons-outlined" style="color: var(--v-profileAnchorColor-base);">receipt_long</span>
        <span v-else class="material-icons-outlined">receipt_long</span>
        <v-menu
          open-on-hover
          :nudge-width="250"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <span
              class="material-icons"
              style="color: #B3C3BA;"
              v-bind="attrs"
              v-on="on"
            >info</span>
          </template>

          <v-card class="p-4 mainColor--text">
            <div class="font-weight-bold mb-4" style="font-size: 1rem;">You have ordered {{ silo.content_report_order?.items_on_checkout?.map(item => item.quantity)?.reduce((a, b) => a + b, 0) }} reports for ${{ silo.content_report_order.price_on_checkout }}</div>
            <div 
              v-if="silo?.content_report_order?.order_status === 'to_be_paid_by_invoice'"
              class="font-weight-bold mb-4" style="color: var(--v-profileAnchorColor-base);"
            >
              Not yet paid. Invoice is due: {{ new Date(silo?.content_report_order?.stripe_invoice_to_be_finalized_at).toDateString() }}
            </div>
            <div v-for="item, index in silo.content_report_order?.items_on_checkout || []" :key="index">
              <template v-if="item.type === 'top_level'">
                <div class="font-weight-bold mb-1">{{ item.quantity }} reports for Top-level keywords</div>
                <div>{{ item.report_label }}</div>
                <div class="mb-3">({{ item.quantity }}x ${{ item.unit_amount }} USD)</div>
              </template>
              <template v-else-if="item.type === 'supporting'">
                <div class="font-weight-bold mb-1">{{ item.quantity }} reports for Supporting keywords</div>
                <div>{{ item.report_label }}</div>
                <div>({{ item.quantity }}x ${{ item.unit_amount }} USD)</div>
              </template>
              <template v-else-if="item.type === 'speedy_delivery'">
                <div class="font-weight-bold mb-1">Speedy delivery</div>
                <div>(${{ item.unit_amount }} USD)</div>
              </template>
            </div>
            <template v-if="silo.content_report_order.applied_coupon_type">
              <div class="font-weight-bold mb-1 mt-4">Applied coupon</div>
              <div>{{ silo.content_report_order.applied_coupon_type === 'Amount Off' ? '$':'' }}{{ silo.content_report_order.applied_coupon_amount_off }}{{ silo.content_report_order.applied_coupon_type === 'Percent Off' ? '%':'' }} off</div>
            </template>
          </v-card>
        </v-menu>

        <span class="price-on-checkout">${{ silo.content_report_order.price_on_checkout }}</span>
      </div>
      <div
        v-if="['paid'].includes(silo?.content_report_order?.order_status) && silo?.content_report_order?.due_date"
        class="footer-item tooltip"
        data-tooltip="Due date"
      >
        <span class="material-icons-outlined">alarm_on</span>
        <span>{{ showDate(silo.content_report_order.due_date) }}</span>
      </div>

      <b-dropdown
        v-if="isWhiteGloveUser && isMissionControlSession && silo.content_report_order"
        aria-role="list" @click.native.stop
        class="sales-tag-dropdown"
      >
        <template #trigger>
          <v-btn
            style="min-width: max-content"
            class="sales-tag-btn"
            small
            :color="silo.content_report_order.sales_tag === 'active' ? 'success' : undefined"
          >
            <template v-if="silo.content_report_order.sales_tag === 'passive'">P</template>
            <template v-else-if="silo.content_report_order.sales_tag === 'active'">A</template>
            <template v-else-if="!silo.content_report_order.sales_tag">-</template>
            <template v-else>{{ silo.content_report_order.sales_tag }}</template>
          </v-btn>
        </template>
        <b-dropdown-item :disabled="silo.content_report_order.sales_tag === 'passive'" aria-role="listitem" @click.native.stop="updateOrder({sales_tag: 'passive'})">Set as passive sale</b-dropdown-item>
        <b-dropdown-item :disabled="silo.content_report_order.sales_tag === 'active'" aria-role="listitem" @click.native.stop="updateOrder({sales_tag: 'active'})">Set as <b>active sale</b></b-dropdown-item>
      </b-dropdown>

    </footer>

    <div class="modal" :class="{ 'is-active': !!showDeleteConfirmModal }">
      <div class="modal-background" @click.stop="showDeleteConfirmModal = false"></div>
      <div class="modal-content">
        <div class="box modal-container" style="overflow: hidden">
          <div class="modal-content-root">
            <div class="title-font is-size-4 mainColor--text">
              You’re about to delete this silo
            </div>
            <div class="control flex mt20">
              <div class="flex-grow-1"></div>
              <v-btn
                rounded
                outlined
                color="mainColor"
                class="button-with-icon mainColor--text text-none"
                @click.stop="showDeleteConfirmModal = false"
              >
                <span>Cancel</span>
              </v-btn>
              <v-btn
                rounded
                color="profileAnchorColor"
                class="button-with-icon text-none whiteColor--text"
                @click.stop="deleteSilo"
              >
                <i class="fa fa-trash mr5"></i>
                <span>Delete</span>
              </v-btn>
            </div>
          </div>
        </div>
        <button
          class="custom-modal-close-btn"
          aria-label="close"
          @click.stop="showDeleteConfirmModal = false"
        >
          <i class="material-icons">close</i>
        </button>
      </div>
    </div>

    <connect-silo-to-page-modal
      v-if="showConnectToPageModal"
      :silo="silo"
      @close="showConnectToPageModal = false"
      @submitted="showConnectToPageModal = false; refreshData()"
    />

  </div>
</template>

<script>
import moment from 'moment';
import { getPureServicePkgName } from '@/utils';
import { whiteGlovePlans } from "@/components/plans_constants"
import { getFulfillementStatusLabel } from '@/components/Campaigns/content-orders/utils.js'
import ConnectSiloToPageModal from './ConnectSiloToPageModal.vue';

export default {
  components: { ConnectSiloToPageModal },
  props: ['silo', 'isProjectLevelView', 'refreshData'],
  data() {
    return {
      isCardInEditMode: false,
      editedName: '',
      showDeleteConfirmModal: false,
      showConnectToPageModal: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    isWhiteGloveUser () {
      if (!this.user) return false;

      const accountType = this.$store.state.selectedSubAccountRelation
        ?this.$store.state.selectedSubAccountRelation.ownerAccountType
        :this.user.accountType

      if (whiteGlovePlans.includes(getPureServicePkgName(accountType))) {
        return true;
      }
      return false;
    },
    isMissionControlSession () {
      return this.$store.state.selectedSubAccountRelation?.isMissionControlSubAccount
    },
    countValue () {
      if (this.isWhiteGloveUser) {
        return (
          (this?.silo?.content_report_order?.selected_top_level_keyword_ids?.length || 0)
          + (this?.silo?.content_report_order?.selected_supporting_keyword_ids?.length || 0)
        )
      } else {
        return this?.silo?.silo_keywords?.filter?.(keyword => !keyword?.isDeleted)?.length || 0
      }
    }
  },
  methods: {
    getFulfillementStatusLabel: getFulfillementStatusLabel,
    showElaspedTime(time) {
      return moment.utc(time).fromNow();
    },
    showDate(time) {
      return moment.utc(time).format("MMM DD");
    },
    onSiloClick(mouseButton='left') {
      const path = `/sites/${this.silo.siteId}/campaign/${this.silo.campaignId}/silo?id=${this.silo.id}`
      if (mouseButton === 'middle') {
        window.open(this.$router.resolve(path).href, '_blank');
        return false
      } else {
        this.$router.push(path);
      }
    },
    saveEditName() {
      if (this.editedName === this.silo.name) {
        // wait a little in case save is too fast
        // (this fix is needed to prevent navigating to silo when save is triggered by clicking on the silo card)
        return new Promise(r => setTimeout(r, 300))  
          .then(() => {
            this.isCardInEditMode = false;
          }) 
      }
  
      this.updateSilo(
        { name: this.editedName }, true
      )
        .then(() => {
          this.$notify({
            group: 'info',
            type: 'success',
            text: 'Successfully updated silo.',
          });
  
          // wait a little in case save is too fast
          // (this fix is needed to prevent navigating to silo when save is triggered by clicking on the silo card)
          return new Promise(r => setTimeout(r, 300))  
            .then(() => {this.isCardInEditMode = false;// this.editableSiteId = null;
          })
        })
    },
    updateSilo(payload, refresh = false) {
      this.$store.commit('showLoading');
      return this.$store
        .dispatch('updateSilo', {
          siloId: this.silo.id,
          body: payload,
        })
        .then(() => {
          if (refresh) {
            this.refreshData();
          }
          return Promise.resolve()
        })
        .finally(() => {
          this.$store.commit('hideLoading');
        });
    },
    deleteSilo() {
      this.$store.commit('showLoading');
      this.$store
        .dispatch('deleteSilo', this.silo.id)
        .then(() => {
          this.$notify({
            group: 'info',
            type: 'success',
            text: 'Successfully deleted silo.',
          });
          this.showDeleteConfirmModal = false;
          this.refreshData();
        });
    },
    updateOrder(payload) {
      this.$store.commit('showLoading');
      this.$store.dispatch('updateSiloContentReportOrder', {
        orderId: this.silo.content_report_order.id,
        body: payload
      })
      .then(response => {
        if (response.data && response.data.status == 'SUCCESS') {
          this.refreshData()
        }
      })
      .finally(() => {
        this.$store.commit('hideLoading');
      })
    },
  },
};

</script>

<style lang="scss" scoped>
@import './silo.scss';

.page-type-drodown {
  .dropdown-item {
    font-weight: normal;
  }

  &.is-disabled {
    opacity: initial;
    cursor: default;
  }
}

.page-type-btn {
  text-transform: initial;
  letter-spacing: initial;
}

.page-type-assign-btn {
  border: 1px dashed #ccc;
}

.sales-tag-dropdown {
  position: relative;
  
  .dropdown-item {
    font-weight: normal;
  }

  &.is-disabled {
    opacity: initial;
    cursor: default;
  }
}

.sales-tag-btn {
  text-transform: initial;
  letter-spacing: initial;
}
</style>
